/**
 * Function not returning any renderer for all kind of attachments
 */
export function noAttachmentRenderer(): null {
  return null;
}
